var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-barcode-record" }, [
    _c("div", { staticClass: "top-bar" }, [
      _c("div", { staticClass: "top-total" }, [
        _c("div", [_vm._v("累计关联：" + _vm._s(_vm.totalCount) + "台")]),
        _c("div", { staticClass: "top-tip" }, [_vm._v("按批次号展示")])
      ])
    ]),
    _vm.mode === "submit"
      ? _c(
          "div",
          { staticClass: "record-card" },
          [
            _vm._m(0),
            _vm._l(_vm.submitList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "record-table-row" },
                [
                  _c("div", { staticClass: "col col-time" }, [
                    _c("div", [_vm._v(_vm._s(item.date))]),
                    _c("div", [_vm._v(_vm._s(item.time))])
                  ]),
                  _c("div", { staticClass: "col col-user" }, [
                    _vm._v(_vm._s(item.userName))
                  ]),
                  _c("div", { staticClass: "col col-count" }, [
                    _vm._v(_vm._s(item.count) + "台")
                  ])
                ]
              )
            }),
            _vm.submitList.length
              ? _c("div", { staticClass: "record-loading" }, [
                  _vm._v(_vm._s(_vm.isShowAll ? "已展示全部记录" : "加载中..."))
                ])
              : _vm._e(),
            _vm.loaded && !_vm.submitList.length
              ? _c("div", { staticClass: "record-empty" }, [
                  _vm._v("暂无关联记录")
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm.mode === "batch"
      ? _c(
          "div",
          { staticClass: "record-card" },
          [
            _vm._m(1),
            _vm._l(_vm.batchList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "record-table-row" },
                [
                  _c("div", { staticClass: "col col-batch-no" }, [
                    _vm._v(_vm._s(item.batchNo))
                  ]),
                  _c("div", { staticClass: "col col-batch-bound" }, [
                    _vm._v(_vm._s(item.boundCount) + "台")
                  ]),
                  _c("div", { staticClass: "col col-batch-unbound" }, [
                    _vm._v(_vm._s(item.unboundCount) + "台")
                  ])
                ]
              )
            }),
            _vm.batchLoaded && !_vm.batchList.length
              ? _c("div", { staticClass: "record-empty" }, [
                  _vm._v("暂无批次记录")
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "record-table-header" }, [
      _c("div", { staticClass: "col col-time" }, [_vm._v("时间")]),
      _c("div", { staticClass: "col col-user" }, [_vm._v("提交人")]),
      _c("div", { staticClass: "col col-count" }, [_vm._v("提交数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "record-table-header" }, [
      _c("div", { staticClass: "col col-batch-no" }, [_vm._v("批次号")]),
      _c("div", { staticClass: "col col-batch-bound" }, [_vm._v("已关联数量")]),
      _c("div", { staticClass: "col col-batch-unbound" }, [
        _vm._v("未关联数量")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }